import { boolean, object } from "yup";
import { useEffect, useState } from "react";

import Validations from "@helpers/validations";
import getColumns from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    name            : "",
    is_special_stage: false,
    status          : ""
};

const useDynamicStages = () => {
    const { platformId } = useParams();      
    const { getSearchParams } = useSearchParams();
    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({
        open: false,
        row : {}
    });

    const { requiredValidation, minMaxRequiredString } = Validations();

    const [data, setData] = useState({
        stages    : [],
        pagination: {
            total: 0,
            limit: 0,
            count: 0,
            page : 1
        }
    }); 
    const { axiosInstance, loading, cancelAllRequests } = useAxios({ base: "panel", initialLoader: true });
    const { axiosInstance: upsertAxiosInstance, loading: upsertLoading } = useAxios({ base: "panel" });

    const methods = useForm({
        defaultValues,
        resolver: yupResolver(object({
            name            : minMaxRequiredString({ name: "Name", min: 3, max: 50 }),
            is_special_stage: boolean(),
            status          : requiredValidation({ name: "Status" })
        }))
    });

    const { reset, handleSubmit } = methods;

    const getAllStages = async  () => {
        const { data } = await axiosInstance.get(`/stages/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({ ...data, pagination: { ...data.pagination, count: data.pagination.total } });
    };

    const toggleModal = (data = defaultValues) => {
        setModalConfig((prev) => ({ row: data, open: !prev.open }));
        reset(data);
    };

    const onSubmit = () => {
        handleSubmit(async (data) => {
            const payload = {
                name            : data.name,
                is_special_stage: data.is_special_stage,
                status          : data.status
            };

            if (!modalConfig.row._id) {
                await upsertAxiosInstance.post(`/stages/${platformId}`, payload);
            } else {
                await upsertAxiosInstance.patch(`/stages/${platformId}/${modalConfig.row._id}`, payload);
            }

            getAllStages();
            toggleModal();
        })();
    };

    const handleRowActions = async (action, row) => {
        if (action === "delete") {
            await upsertAxiosInstance.delete(`/stages/${platformId}/${row._id}`);
            getAllStages();
            return;
        }
        toggleModal(row);
    };

    useEffect(() => {
        let active = true;
        if (active) {
            getAllStages();
        }

        return () => {
            active = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    const columns = getColumns({ handleRowActions });

    return {
        getAllStages,
        loading,
        data,
        columns,
        setQueryParams,
        toggleModal,
        modalConfig,
        methods,
        upsertLoading,
        onSubmit
    };
};

export default useDynamicStages;